import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import TabIndicator from './tab/TabIndicator';
import CloseButton from './tab/CloseButton';
import ErrorIcon from './tab/ErrorIcon';
import theme from 'theme/theme';

const TabListItemActive = css`
    border-bottom: 1px solid ${ theme.palette.white };
`;

const TabListItem = styled.li`
    position: relative;
    display: flex;
    margin-bottom: -1px;
    width: 100%;
    height: 60px;
    justify-content: space-between;
    align-items: center;
    background-color: ${ theme.palette.white };
    border: solid ${ theme.palette.silver };
    border-width: 1px 1px 1px 0;
    list-style: none;
    cursor: pointer;

    ${ (props) => {
        return props.active &&
            TabListItemActive;
    } }

    &:first-child {
        border-left-width: 1px;
    }
`;

const StyledLabel = styled.div`
    position: relative;
    display: flex;
    flex: 1 0 0;
    height: 100%;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    user-select: none;
`;

const Tab = (props) => {
    const {
        error,
        index,
        label,
        locked,
        onClick,
        onRemoveTab,
        selectedIndex,
    } = props;

    const isActive = selectedIndex === index;

    const handleOnClick = () => {
        onClick(index);
    };

    const handleRemoveTab = () => {
        onRemoveTab(index, label);
    };

    return (
        <TabListItem
            active={ isActive }
            selectedIndex={ selectedIndex }
        >
            <TabIndicator
                active={ isActive }
                error={ error }
            />

            <StyledLabel
                onClick={ handleOnClick }
            >
                { label }

                { error &&
                    <ErrorIcon error={ error } />
                }
            </StyledLabel>

            { !locked &&
                <CloseButton
                    onClick={ handleRemoveTab }
                />
            }
        </TabListItem>
    );
};

Tab.defaultProps = {
    error: false,
    locked: true,
};

Tab.propTypes = {
    error: PropTypes.bool,
    index: PropTypes.number,
    label: PropTypes.string.isRequired,
    locked: PropTypes.bool,
    onClick: PropTypes.func,
    onRemoveTab: PropTypes.func,
    selectedIndex: PropTypes.number,
};

export default Tab;



// WEBPACK FOOTER //
// ./src/components/tabs/Tab.js